import { Box, Button as MUIButton, TextField, Typography } from "@mui/material";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import { Card, CardBody, Input, Label } from "reactstrap";

import { API_URL } from "app/config";
import { store } from "app/store";
import CustomSearchBar from "components/CustomSearchBar";
import { selectCurrentUser } from "features/auth/authSlice";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import swal from "sweetalert";
import DigitalAgricultureFileResponse from "./DigitalAgricultureFileResponse";
import DigitalAgricultureMap from "./DigitalAgricultureMap";
import DigitalAgricultureNavbar from "./DigitalAgricultureNavbar";
import DigitalBenchmarkDetails from "./DigitalBenchmarkDetails";
import { useGetDigitalAgricultureQuery } from "./RiskManagementApiSlice";
import RiskManagementDigitalAgricultureMainMap from "./RiskManagementDigitalAgricultureMainMap";

const DigitalAgricultureInsights = () => {
  const currentUser = useSelector(selectCurrentUser);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [showLoaderTable, setLoaderTable] = useState(true);
  const [rowsPerPage, setRowsperPage] = useState(10);
  const [show, setShow] = useState(false);
  const [latlongData, setLatLongData] = useState([]);
  const [pagination, setPagination] = useState({
    offset: 0,
    limit: rowsPerPage,
    currentPage: 1,
  });
  const [dateKey, setDate] = useState("");

  const [selectedSurveyType, setSelectedSurveyType] = useState("GT");

  const {
    data: getGtSurvey,
    refetch,
    isLoading,
    isFetching,
  } = useGetDigitalAgricultureQuery(
    {
      pagination,
      searchKey: debouncedSearch || "",
      dateKey,
      surveyType: selectedSurveyType,
    },
    { skip: !selectedSurveyType }
  );

  // const { data: getGtSurvey, refetch, isLoading, isFetching } =
  //   selectedSurveyType === "CH" ? ChPoint : GtPoint;
  const [GtPointSurvey, setGtPointSurvey] = useState([]);
  const [cropdata, setDetailList] = useState([]);
  const [cropdataLatLong, setDetailLatLong] = useState([]);
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");
  const [cardName, setCardValue] = useState("Details");
  const [editAllowed, setEditAllowed] = useState(false);
  const [editableFields, setEditableInputFields] = useState({
    CropName: "",
    CropVariety: "",
    PestiscideName: "",
    Remarks: "",
  });
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [StartdateKey, setStartDate] = useState("");
  const [EndDateKey, setEndDate] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const [StartdateKeyWithoutDocument, setStartDateWithoutDocument] = useState(
    ""
  );

  const [EndDateKeyWithoutDocument, setEndDateWithoutDocument] = useState("");
  const [dateRangeWithoutDocument, setDateRangeWithoutDocument] = useState([]);
  const [
    downloadLoadingWithoutDocument,
    setDownloadLoadingWithoutDocument,
  ] = useState(false);
  const [SortedArray, setSortedArray] = useState([]);
  const [FileModal, setFileModal] = useState(false);
  const [ShowBenchmark, setShowBenchmark] = useState(false);
  const [benchmarkDetails, setbenchmarkDetails] = useState("");

  useEffect(() => {
    setPagination({ ...pagination, limit: rowsPerPage });
    setLoaderTable(false);
  }, [rowsPerPage]);
  useEffect(() => {
    refetch();
  }, [refetch]);
  useEffect(() => {
    if (getGtSurvey !== undefined) {
      setGtPointSurvey(getGtSurvey?.data?.results);
      setLoaderTable(true);
    }
  }, [getGtSurvey]);
  useEffect(() => {
    const FilteredLatLong = [];
    GtPointSurvey?.map((item) => {
      if (Array.isArray(item.LatLong)) {
        FilteredLatLong.push(item.LatLong);
      }
    });
    setLatLongData(FilteredLatLong);
  }, [GtPointSurvey]);
  const handleShow = (list) => {
    setDetailList(list);
    setShow(true);
    // if (Array.isArray(list?.Fertilizers)) {
    //   setDetailFertilizerList(list?.Fertilizers);
    // }
    // if (Array.isArray(list?.IrrigationInterval)) {
    //   setDetailIrrigationList(list?.IrrigationInterval);
    // }
    if (Array.isArray(list?.LatLong)) {
      setDetailLatLong(list?.LatLong);
    }
    setEditableInputFields({
      CropName: list.cropName,
      CropVariety: list.cropVariety,
      PestiscideName: list.PestiscideName,
      Remarks: list.OtherRemark,
    });
    if (list?.Media?.length > 0) {
      const sortedData = [...list.Media]?.sort(function(a, b) {
        const attributeA = parseInt(a.Attribute.split("-")[1].trim());
        const attributeB = parseInt(b.Attribute.split("-")[1].trim());
        return attributeA - attributeB;
      });
      setSortedArray(sortedData);
    }
  };

  const state = {
    sortOrder: {},
    data: ["Loading Data..."],
    columns: [
      {
        name: "SurveyNo",
        label: selectedSurveyType === "BM" ? "Benchmark No" : "Survey No",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CreatedOn",
        label: "Created Date",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CreatedMobile",
        label: "Phone No",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CropName",
        label: "Crop Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CropCategoryName",
        label: "Crop Category",
        options: {
          filter: true,
          sort: true,
        },
      },

      ...(selectedSurveyType === "CH"
        ? [
            {
              name: "CropVariety",
              label: "Crop Variety",
              options: {
                filter: true,
                sort: true,
              },
            },
          ]
        : []),

      {
        name: "CroppingTypeName",
        label: "Cropping Type",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "StateName",
        label: "State",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "DistrictName",
        label: "District",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "VillageName",
        label: "Village",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "view_details",
        label: "View ",
        options: {
          filter: true,
          sort: true,
          download: false,
        },
      },
    ],

    isLoading: false,
  };

  const getSrcData =
    GtPointSurvey &&
    GtPointSurvey?.map((list, index) =>
      list !== undefined
        ? {
            SurveyNo: list.SurveyNo,
            CreatedName: (
              <div className="text-center"> {list.CreatedName} </div>
            ),
            CreatedMobile: (
              <div className="text-center"> {list.CreatedMobile} </div>
            ),
            CropName: <div className="text-center"> {list.CropName} </div>,
            CropCategoryName: (
              <div className="text-center"> {list.CropCategoryName} </div>
            ),
            CropVariety: (
              <div className="text-center"> {list.CropVariety} </div>
            ),
            CreatedOn: (
              <div className="text-center">
                {list.CreatedOn ? list.CreatedOn.slice(0, 10) : ""}
              </div>
            ),
            CroppingTypeName: (
              <div className="text-center"> {list.CroppingTypeName} </div>
            ),
            StateName: <div className="text-center"> {list.StateName} </div>,
            DistrictName: (
              <div className="text-center"> {list.DistrictName} </div>
            ),
            VillageName: (
              <div className="text-center"> {list.VillageName} </div>
            ),

            view_details: (
              <div
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <span
                  className="mdi mdi-eye mx-3 fs-6 OrangeColorClass"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleShow(list)}
                  title="View "
                ></span>

                {selectedSurveyType === "BM" && (
                  <i
                    className="mdi mdi-chart-line text-success fs-5"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowBenchmark(true);
                      setbenchmarkDetails(list);
                    }}
                    title="Benchmark View"
                  ></i>
                )}
              </div>
            ),
          }
        : null
    );

  const options = {
    page: pagination.currentPage - 1,
    rowsPerPage: rowsPerPage,
    search: false,
    download: false,
    count: getGtSurvey?.data?.count || 0,
    rowsPerPageOptions: [10, 50, 100, 500, 1000],
    serverSide: true,
    filterType: "dropdown",
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    textLabels: {
      pagination: {
        next: "Next >",
        previous: "< Previous",
        rowsPerPage: "Total Per Page",
        displayRows: "OF",
      },
      body: {
        noMatch:
          isLoading || isFetching ? <Spinner size={24} /> : "No data available",
      },
    },
    onChangePage(currentPage) {
      setLoaderTable(true);
      setPagination({
        offset: currentPage * rowsPerPage,
        limit: rowsPerPage,
        currentPage: currentPage + 1,
      });
    },
    onChangeRowsPerPage(numberOfRows) {
      setRowsperPage(numberOfRows);
      setLoaderTable(true);
    },
  };

  const handleClose = (val) => {
    setShow(false);
    setCardValue("Details");
    setEditAllowed(false);
  };
  const handleLightBoxImage = (image) => {
    setImageInLightbox(image);
    setOpenLightBox(true);
  };

  const handleActiveCard = (cardName) => {
    setCardValue(cardName);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500);

    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleDateChange = (e) => {
    let date = new Date(e.target.value);
    let dateMDY = `${date.getDate()}/${date.getMonth() +
      1}/${date.getFullYear()}`;
    setSearchKey("");
    if (dateMDY === "NaN/NaN/NaN") {
      setDate("");
    } else setDate(dateMDY);
  };

  const handleStartEndDate = (value) => {
    setDateRange(value);
    if (value !== null && value.length > 0) {
      value.map((item, index) => {
        const inputDate = new Date(item);
        const formattedDate = moment(inputDate).format("YYYY-MM-DD");
        if (index === 0) {
          setStartDate(formattedDate);
        }
        if (index === 1) {
          setEndDate(formattedDate);
        }
      });
    }
  };
  const disabledDate = (date) => {
    return date && date > new Date();
  };
  const handleClean = () => {
    setDateRange([]);
    setStartDate("");
    setEndDate("");
  };

  const handleStartEndDateWithoutDocument = (value) => {
    setDateRangeWithoutDocument(value);
    if (value !== null && value.length > 0) {
      value.map((item, index) => {
        const inputDate = new Date(item);
        const formattedDate = moment(inputDate).format("YYYY-MM-DD");
        if (index === 0) {
          setStartDateWithoutDocument(formattedDate);
        }
        if (index === 1) {
          setEndDateWithoutDocument(formattedDate);
        }
      });
    }
  };
  const disabledDateWithoutDocument = (date) => {
    return date && date > new Date();
  };
  const handleCleanWithoutDocument = () => {
    setDateRangeWithoutDocument([]);
    setStartDateWithoutDocument("");
    setEndDateWithoutDocument("");
  };
  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedSurveyType(selectedValue);
  };
  //   const [dateKey, setDateKey] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [type, setType] = useState("");
  const [range, setRange] = useState([null, null]);

  const openPopover = (e) => {
    setAnchorEl(e.currentTarget);
    setType("");
    setRange([null, null]);
  };
  const closePopover = () => {
    setAnchorEl(null);
    setType("");
    setRange([null, null]);
  };
  const download = () => {
    if (!range[0] || !range[1]) return;
    closePopover();
  };

  const handleChangeSearch = (message) => {
    setSearchKey(message);
  };
  return (
    <div>
      <DigitalAgricultureNavbar />
      <Box
        sx={{ p: 2, marginTop: -1 }}
        className="position-relative container-fluid px-lg-5 "
      >
        <div className="">
          <div className="bg-white border rounded  p-4 mt-4 d-flex justify-content-between align-items-center ">
            <div className="">
              <Label className=" text-end textColorHeading ">
                <h5>Select Survey Type</h5>
              </Label>

              <div className="d-flex flex-wrap gap-3">
                {["GT", "CH", "BM"].map((type) => (
                  <div key={type} className="d-flex align-items-center ">
                    <Input
                      type="radio"
                      id={type}
                      value={type}
                      name="surveyType"
                      checked={selectedSurveyType === type}
                      className="form-check-input mx-1 f500 cursor"
                      style={{ marginTop: "-5px" }}
                      onChange={(event) => {
                        handleSelectChange(event);
                        setPagination({ offset: 0, limit: 10, currentPage: 1 });
                      }}
                    />
                    <label className=" f400 mx-1" htmlFor={type}>
                      {type === "GT"
                        ? "GT"
                        : type === "CH"
                        ? "CHM"
                        : "Benchmark"}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <Row
              className="d-flex justify-content-end py-2"
              style={{ marginRight: "5px" }}
            >
              <Col lg="2" className="d-flex align-items-center">
                <CustomSearchBar sendSearchFunction={handleChangeSearch} />
              </Col>

              <Col lg="2" className="d-flex align-items-center">
                <Input
                  type="date"
                  size="sm"
                  defaultValue={dateKey}
                  onChange={(e) => handleDateChange(e)}
                />
              </Col>

              <Col lg="3" className="mt-1">
                <Box sx={{ position: "relative" }}>
                  <Typography
                    fontWeight={500}
                    sx={{ mb: 1, position: "absolute", top: -20, zIndex: 100 }}
                  >
                    📁 With Documents
                  </Typography>
                  <div className="d-flex align-items-center ">
                    <DateRangePicker
                      calendars={1}
                      value={dateRange}
                      onChange={handleStartEndDate}
                      disabledDate={disabledDate}
                      onClean={handleClean}
                      renderInput={(startProps, endProps) => (
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <TextField
                            {...startProps}
                            label="Start"
                            fullWidth
                            size="small"
                          />
                          <TextField
                            {...endProps}
                            label="End"
                            fullWidth
                            size="small"
                          />
                        </Box>
                      )}
                    />
                    {StartdateKey && EndDateKey && (
                      <Button
                        variant="success"
                        size="sm"
                        className="mx-2"
                        onClick={() => {
                          const state = store.getState();
                          setDownloadLoading(true);
                          fetch(
                            `${API_URL}/survey/${
                              selectedSurveyType === "GT"
                                ? "gt"
                                : selectedSurveyType === "CH"
                                ? "ch"
                                : "bm"
                            }-digital-agriculture/download/?start_date=${StartdateKey}&end_date=${EndDateKey}`,
                            {
                              headers: {
                                authorization: `Bearer ${state.auth.accessToken}`,
                              },
                            }
                          )
                            .then(async (response) => {
                              const res = await response.json();
                              if (
                                !res.data ||
                                Object.keys(res.data).length === 0
                              ) {
                                swal(`${res.message}`, {
                                  buttons: false,
                                  icon: "warning",
                                  timer: 7500,
                                });
                                setDownloadLoading(false);
                                return;
                              }
                              const fileURL = res.data?.link || "";
                              let alink = document.createElement("a");
                              alink.href = fileURL;
                              alink.download =
                                "application" +
                                new Date().toDateString() +
                                ".csv";
                              alink.click();
                              setDateRange([]);
                              setStartDate("");
                              setEndDate("");
                              setDownloadLoading(false);
                            })
                            .catch(() => setDownloadLoading(false));
                        }}
                      >
                        <i className="mdi mdi-download " />
                      </Button>
                    )}
                  </div>
                </Box>
              </Col>

              <Col lg={"3"} className="mt-1">
                <Box sx={{ position: "relative" }}>
                  <Typography
                    fontWeight={500}
                    sx={{ mb: 1, position: "absolute", top: -20, zIndex: 100 }}
                  >
                    📁 Without Documents
                  </Typography>
                  <div className="d-flex align-items-center overflow-hidden">
                    <DateRangePicker
                      calendars={1}
                      value={dateRangeWithoutDocument}
                      onChange={handleStartEndDateWithoutDocument}
                      disabledDate={disabledDateWithoutDocument}
                      onClean={handleCleanWithoutDocument}
                      renderInput={(startProps, endProps) => (
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <TextField
                            {...startProps}
                            label="Start"
                            fullWidth
                            size="small"
                          />
                          <TextField
                            {...endProps}
                            label="End"
                            fullWidth
                            size="small"
                          />
                        </Box>
                      )}
                    />
                    {StartdateKeyWithoutDocument && EndDateKeyWithoutDocument && (
                      <Button
                        variant="success"
                        size="sm"
                        color="warning"
                        className="mx-2"
                        onClick={() => {
                          const state = store.getState();
                          fetch(
                            `${API_URL}/survey/${
                              selectedSurveyType === "GT"
                                ? "gt"
                                : selectedSurveyType === "CH"
                                ? "ch"
                                : "bm"
                            }-digital-agriculture/without-media-download/?start_date=${StartdateKeyWithoutDocument}&end_date=${EndDateKeyWithoutDocument}`,
                            {
                              headers: {
                                authorization: `Bearer ${state.auth.accessToken}`,
                              },
                            }
                          )
                            .then((res) => res.json())
                            .then((res) => {
                              if (
                                !res.data ||
                                Object.keys(res.data).length === 0
                              ) {
                                swal(`${res.message}`, {
                                  buttons: false,
                                  icon: "warning",
                                  timer: 7500,
                                });
                                setDownloadLoadingWithoutDocument(false);
                                return;
                              }
                              const fileURL = res.data?.link || "";
                              let alink = document.createElement("a");
                              alink.href = fileURL;
                              alink.download = "farmers.csv";
                              alink.click();
                              setDownloadLoadingWithoutDocument(false);
                              setDateRangeWithoutDocument([]);
                              setStartDateWithoutDocument("");
                              setEndDateWithoutDocument("");
                            })
                            .catch(() =>
                              setDownloadLoadingWithoutDocument(false)
                            );
                        }}
                      >
                        <i className="mdi mdi-download " />
                      </Button>
                    )}
                  </div>
                </Box>
              </Col>

              <Col lg="1" className="mt-1">
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => setFileModal(true)}
                >
                  {/* <i className="mdi mdi-cloud-download-outline me-2" /> */}
                  Download
                </Button>
              </Col>
            </Row>
          </div>

          <Col sm="12" className="mt-3">
            <Card className=" shadow-map p-1">
              <CardBody className="p-3 " style={{ backgroundColor: "#F5F5F5" }}>
                <RiskManagementDigitalAgricultureMainMap
                  GtPointSurvey={GtPointSurvey}
                  latlongData={latlongData}
                  refetch={refetch}
                  selectedSurveyType={selectedSurveyType}
                />
              </CardBody>
            </Card>
          </Col>
        </div>
        <Row className=" ">
          <Col className="col-12  ">
            <Card>
              <MUIDataTable
                className="shadow-none"
                data={getSrcData}
                loading={showLoaderTable}
                columns={state.columns}
                options={options}
              />
            </Card>
          </Col>
          <Modal
            show={show}
            onHide={handleClose}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            size="xl"
            style={{ marginTop: "" }}
          >
            <Modal.Header closeButton style={{ marginTop: "" }}>
              <Modal.Title>Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg="1"></Col>
                <div className="">
                  <div
                    className="radio-inputs text-center"
                    style={{ width: "45%", margin: "auto" }}
                  >
                    <label className="radio">
                      <div onClick={() => handleActiveCard("Details")}>
                        <input type="radio" name="radio" defaultChecked />
                        <h5 className="name2  m-0">Details</h5>
                      </div>
                    </label>
                    <label className="radio">
                      <div onClick={() => handleActiveCard("Documents")}>
                        <input type="radio" name="radio" />
                        <h5 className="name2 text-primary m-0">Documents</h5>
                      </div>
                    </label>
                    <label className="radio">
                      <div onClick={() => handleActiveCard("Geo Tag")}>
                        <input type="radio" name="radio" />
                        <h5 className="name2 text-primary m-0">Geo Tag</h5>
                      </div>
                    </label>
                  </div>
                  {cardName === "Details" ? (
                    <>
                      <Card>
                        <CardBody>
                          <h6 className="mt-3 mb-3 text-primary">Basic Info</h6>
                          <Row className="mb-3">
                            <Col lg="3">
                              <Label>Created Name</Label>
                              <Input
                                disabled
                                value={cropdata?.CreatedName || "-"}
                              />
                            </Col>
                            <Col lg="3">
                              <Label>Created Phone No</Label>
                              <Input
                                disabled
                                value={cropdata?.CreatedMobile || "-"}
                              />
                            </Col>
                            <Col lg="3">
                              <Label>Lat/Long</Label>
                              <Input
                                disabled
                                value={
                                  cropdataLatLong.length > 0
                                    ? `${cropdataLatLong[0].lat.toFixed(
                                        4
                                      )}/${cropdataLatLong[0].long.toFixed(4)}`
                                    : "-"
                                }
                              />
                            </Col>
                          </Row>

                          <h6 className="mt-3 mb-3 text-primary">
                            Crop Details
                          </h6>
                          <Row className="mb-3">
                            <Col lg="3">
                              <Label>Crop Name</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.CropName || "-"}
                              />
                            </Col>
                            <Col lg="3">
                              <Label>Crop Category</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.CropCategoryName || "-"}
                              />
                            </Col>
                            {selectedSurveyType === "CH" && (
                              <Col lg="3">
                                <Label>Crop Variety</Label>
                                <Input
                                  disabled
                                  value={cropdata?.CropVariety || "-"}
                                />
                              </Col>
                            )}
                            <Col lg="3">
                              <Label>Crop Condition</Label>
                              <Input
                                disabled
                                value={cropdata?.CropConditionName || "-"}
                              />
                            </Col>
                          </Row>

                          <h6 className="mt-3 mb-3 text-primary">
                            Cropping Details
                          </h6>
                          <Row className="mb-3">
                            <Col lg="3">
                              <Label>Cropping Type</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.CroppingTypeName || "-"}
                              />
                            </Col>
                            <Col lg="3">
                              <Label>Season</Label>
                              <Input disabled value={cropdata?.Season || "-"} />
                            </Col>
                            <Col lg="3">
                              <Label>Sowing Date</Label>
                              <Input
                                disabled
                                value={cropdata?.SowingDate || "-"}
                              />
                            </Col>
                            <Col lg="3">
                              <Label>Harvest Date</Label>
                              <Input
                                disabled
                                value={cropdata?.HarvestDate || "-"}
                              />
                            </Col>
                            <Col lg="3" className="mt-3">
                              <Label>Crop Damage</Label>
                              <Input
                                disabled
                                value={cropdata?.CropDamageType || "-"}
                              />
                            </Col>
                          </Row>

                          <h6 className="mt-3 mb-3 text-primary">
                            Area Details
                          </h6>
                          <Row className="mb-3">
                            <Col lg="3">
                              <Label>Plot Area</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.PlotArea || "-"}
                              />
                            </Col>
                            <Col lg="3">
                              <Label>Polygon Area</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.PolygonArea || "-"}
                              />
                            </Col>
                            <Col lg="3">
                              <Label>Ratio Of Major Crop</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.RatioOfMajorCrop || "-"}
                              />
                            </Col>
                          </Row>

                          <h6 className="mt-3 mb-3 text-primary">
                            Minor Crop Details
                          </h6>
                          <Row className="mb-3">
                            <Col lg="3">
                              <Label>Minor Crop Name</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.MinorCropName || "-"}
                              />
                            </Col>
                            <Col lg="3">
                              <Label>Minor Crop Category</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.MinorCropCategoryName || "-"}
                              />
                            </Col>
                            <Col lg="3">
                              <Label>Minor Crop Type</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.MinorCropType || "-"}
                              />
                            </Col>
                          </Row>

                          {selectedSurveyType === "CH" && (
                            <>
                              <h6 className="mt-3 mb-3 text-primary">
                                Additional Details
                              </h6>
                              <Row className="mb-3">
                                <Col lg="3">
                                  <Label>Fertilizer Type</Label>
                                  <Input
                                    disabled={!editAllowed}
                                    value={cropdata?.FertilizerType || "-"}
                                  />
                                </Col>
                                <Col lg="3">
                                  <Label>Expected Avg Yield</Label>
                                  <Input
                                    disabled={!editAllowed}
                                    value={cropdata?.ExpectedAvgYield || "-"}
                                  />
                                </Col>
                                <Col lg="3">
                                  <Label>Expected Yield Of Crop</Label>
                                  <Input
                                    disabled={!editAllowed}
                                    value={cropdata?.ExpectedYieldOfCrop || "-"}
                                  />
                                </Col>
                              </Row>
                            </>
                          )}

                          <h6 className="mt-3 mb-3 text-primary">Location</h6>
                          <Row className="mb-3">
                            <Col lg="3">
                              <Label>State</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.StateName || "-"}
                              />
                            </Col>
                            <Col lg="3">
                              <Label>District</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.DistrictName || "-"}
                              />
                            </Col>
                            <Col lg="3">
                              <Label>Village</Label>
                              <Input
                                disabled={!editAllowed}
                                value={cropdata?.VillageName || "-"}
                              />
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                      <Row></Row>
                    </>
                  ) : cardName === "Documents" ? (
                    <Row>
                      {cropdata ? (
                        <Row>
                          {cropdata?.Media
                            ? cropdata?.Media?.map((list, index) =>
                                list.ImagePath !== "" ? (
                                  <Col lg={3} key={list.index} className="mt-3">
                                    <Card className="text-center border ">
                                      <CardBody>
                                        <div className="img-fluid float-left">
                                          <p className="mb-1 text-uppercase">
                                            {list.Attribute}
                                          </p>
                                          <hr className="mt-2" />
                                          {list.ImagePath.includes("mp4") ? (
                                            <video
                                              width="320"
                                              height="240"
                                              controls
                                            >
                                              <source
                                                src={list.ImagePath}
                                                type="video/mp4"
                                              />
                                              <source
                                                src={list.ImagePath}
                                                type="video/ogg"
                                              />
                                            </video>
                                          ) : list.ImagePath.includes("pdf") ? (
                                            <object
                                              data={list.ImagePath}
                                              type="application/pdf"
                                              width="100%"
                                              height="400px"
                                            />
                                          ) : (
                                            <img
                                              src={list.ImagePath}
                                              onClick={() =>
                                                handleLightBoxImage(
                                                  list.ImagePath
                                                )
                                              }
                                              alt=""
                                              className="img-fluid cursor-pointer"
                                            />
                                          )}
                                          <hr className="mt-2" />
                                          <p className="mb-1 text-uppercase">
                                            Accuracy :{" "}
                                            {list.Metadata
                                              ? list.Metadata.Accuracy
                                              : ""}
                                          </p>
                                          <p className="mb-1 text-uppercase">
                                            Azimuth :{" "}
                                            {list.Metadata
                                              ? list.Metadata.azimuth
                                              : ""}
                                          </p>
                                          <p className="mb-1 text-uppercase">
                                            Elevation :
                                            {list.Metadata
                                              ? list.Metadata.Elevation
                                              : ""}
                                          </p>
                                          {openLightbox ? (
                                            <Lightbox
                                              image={lightBoxViewImage}
                                              title="Image Title"
                                              onClose={() =>
                                                setOpenLightBox(false)
                                              }
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                ) : null
                              )
                            : ""}
                          {SortedArray
                            ? SortedArray?.map((list, index) =>
                                list.FileName !== "" ? (
                                  <Col lg={3} key={list.index} className="mt-3">
                                    <Card className="text-center border ">
                                      <CardBody>
                                        <div className="img-fluid float-left">
                                          <p className="mb-1 text-uppercase">
                                            {list.Attribute}
                                          </p>
                                          <hr className="mt-2" />
                                          {list.FileName.includes("mp4") ? (
                                            <video
                                              width="320"
                                              height="240"
                                              controls
                                            >
                                              <source
                                                src={list.FileName}
                                                type="video/mp4"
                                              />
                                              <source
                                                src={list.FileName}
                                                type="video/ogg"
                                              />
                                            </video>
                                          ) : list.FileName.includes("pdf") ? (
                                            <object
                                              data={list.FileName}
                                              type="application/pdf"
                                              width="100%"
                                              height="400px"
                                            />
                                          ) : (
                                            <img
                                              src={list.FileName}
                                              onClick={() =>
                                                handleLightBoxImage(
                                                  list.FileName
                                                )
                                              }
                                              alt=""
                                              className="img-fluid cursor-pointer"
                                            />
                                          )}
                                          <hr className="mt-2" />
                                          <p className="mb-1 text-uppercase">
                                            Accuracy :{" "}
                                            {list.Metadata
                                              ? list.Metadata.Accuracy
                                              : ""}
                                          </p>
                                          <p className="mb-1 text-uppercase">
                                            Azimuth :{" "}
                                            {list.Metadata
                                              ? list.Metadata.azimuth
                                              : ""}
                                          </p>
                                          <p className="mb-1 text-uppercase">
                                            Elevation :
                                            {list.Metadata
                                              ? list.Metadata.Elevation
                                              : ""}
                                          </p>
                                          {openLightbox ? (
                                            <Lightbox
                                              image={lightBoxViewImage}
                                              title="Image Title"
                                              onClose={() =>
                                                setOpenLightBox(false)
                                              }
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                ) : null
                              )
                            : ""}
                        </Row>
                      ) : null}
                    </Row>
                  ) : (
                    <DigitalAgricultureMap
                      listData={cropdata}
                      otherMedia={cropdata.Media}
                      benchmarkDetails=""
                    />
                  )}
                </div>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </Row>
        <Modal show={FileModal} size="xl" onHide={() => setFileModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Download File</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3">
            <DigitalAgricultureFileResponse
              formName={
                selectedSurveyType === "GT"
                  ? "Digital Agriculture - GT"
                  : selectedSurveyType === "CH"
                  ? "Digital Agriculture - CH"
                  : "Digital Agriculture - Benchmark"
              }
            />
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
        <Modal
          show={ShowBenchmark}
          size="xl"
          onHide={() => setShowBenchmark(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Benchmark Details</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3">
            <DigitalBenchmarkDetails benchmarkDetails={benchmarkDetails} />
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      </Box>
    </div>
  );
};

export default DigitalAgricultureInsights;
